<div class="section-container">
    <div class="section-parts flex justify-center">
        <div class="content part1 flex items-end">
            <div class="flex flex-col gap-[16px]">
                <div class="text-title">
                    <div>On</div>
                    <div>Target</div>
                </div>
                <div class="text-content">We have pre-scope, best-matched tech stack and matured agile development cycle to help precision delivery.</div>
            </div>
        </div>
        <div class="content part2"></div>
        <div class="content part3 flex items-end">
            <div class="flex flex-col gap-[16px]">
                <div class="text-title">
                    <div>On</div>
                    <div>Time</div>
                </div>
                <div class="text-content">Tightly managed scrum teams to achieve well monitored sprint cycle with real-time dashboard.</div>
            </div>
        </div>
        <div class="content part4">
            <div class="flex flex-col gap-[16px]">
                <div class="text-title">
                    <div>On</div>
                    <div>Budget</div>
                </div>
                <div class="text-content">We have well scaled team sized, Best skilled and highly disciplined team to fulfill your needs at least cost.</div>
            </div>
        </div>
        <div class="content part5"></div>
    </div>
    <div class="section-parts-mobile flex justify-center flex-col">
        <div class="content part1 flex"></div>
        <div class="content part2">
            <div class="flex flex-col gap-[16px] w-[200px]">
                <div class="text-title">On Budget</div>
                <div class="text-content">We have well scaled team sized, Best skilled and highly disciplined team to fulfill your needs at least cost.</div>
            </div>
        </div>
        <div class="content part3 flex justify-end">
            <div class="flex flex-col gap-[16px] w-[200px]">
                <div class="text-title">On Time</div>
                <div class="text-content">Tightly managed scrum teams to achieve well monitored sprint cycle with real-time dashboard.</div>
            </div>
        </div>
        <div class="content part4"></div>
        <div class="content part5 flex justify-end">
            <div class="flex flex-col gap-[16px] w-[200px]">
                <div class="text-title">On Target</div>
                <div class="text-content">We have pre-scope, best-matched tech stack and matured agile development cycle to help precision delivery.</div>
            </div>
        </div>
    </div>
</div>
